module.exports = __webpack_public_path__ + "img/app-logo.6f68c2f9.png";